export var OnboardingSteps;
(function (OnboardingSteps) {
    OnboardingSteps["MARKETING_DATA"] = "MARKETING_DATA";
    OnboardingSteps["FEATURES"] = "FEATURES";
    OnboardingSteps["GROUPS"] = "GROUPS";
    OnboardingSteps["FINAL_NOTES"] = "FINAL_NOTES";
})(OnboardingSteps || (OnboardingSteps = {}));
export var GroupOptionsOnboarding;
(function (GroupOptionsOnboarding) {
    GroupOptionsOnboarding["EVERYONE"] = "EVERYONE";
    GroupOptionsOnboarding["WHITELIST"] = "WHITELIST";
    GroupOptionsOnboarding["BLACKLIST"] = "BLACKLIST";
})(GroupOptionsOnboarding || (GroupOptionsOnboarding = {}));
//# sourceMappingURL=organisation.js.map